/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import { Heading1, Paragraph } from '@motili/ui';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import { styled } from 'styled-components';
import { useAppSelector } from '../../../common/redux/hooks';
import GetStartedForm from './GetStartedForm';
import BottomButtonNavigation from '../../../navigation/BottomButtonNavigation';

interface GetStartedProps {
    handleBackClick: () => void;
    handleNextClick: () => void;
}

export default function GetStarted({
    handleBackClick,
    handleNextClick,
}: GetStartedProps): ReactElement {
    const starterInfo = useAppSelector(
        ({ clientRegistration }) => clientRegistration.starterInfo
    );
    const steps = useAppSelector(
        ({ clientRegistration }) => clientRegistration.client.totalSteps
    );

    return (
        <CenteredContainer>
            <Paragraph>
                <BoldText>Step 1</BoldText> of {steps}
            </Paragraph>
            <Heading1>Let's Get Started</Heading1>
            <Paragraph>
                Please enter your name, email address and phone number. The
                email address and phone number should be the main number and
                email that we will use to contact you.
            </Paragraph>
            <GetStartedForm starterInfo={starterInfo} />
            <BottomButtonNavigation
                onBackClick={handleBackClick}
                onNextClick={handleNextClick}
                nextDisabled={
                    !starterInfo.firstName ||
                    !starterInfo.lastName ||
                    !starterInfo.email ||
                    starterInfo.phone.length !== 10
                }
            />
        </CenteredContainer>
    );
}

const BoldText = styled.span`
    font-weight: bold;
`;
